import React, { FC } from 'react';
import dynamic from 'next/dynamic';
import triggerTracking from '@blueprint/tracking/dist/Tracking';
import { Tabs, Tab } from 'shared/components/Tabs/Tabs';
import RegisterSection from '../section/Register';
const SignInSection = dynamic(() => import('../section/SignIn'), {
    ssr: false
});
import { SocialAuthProps } from '../AuthModal.types';
import registrationAndSignInTranslations from 'public/locales/en/registration-and-sign-in.json';
import { getTranslator } from 'shared/i18n/getTranslator';
const t = getTranslator(registrationAndSignInTranslations);
const signInTitleTn = t('signIn.title');
const registerTitleTn = t('detailsSection.title');
const headingTn = t('defaultHeading');

export const RegTabs: FC<SocialAuthProps> = (props) => {
    const {
        initialMode = 'register',
        actionAfterAuth,
        resetActionAfterAuth = () => null,
        isShowing,
        heading,
        onSocialAuth,
        close
    } = props;
    return (
        <Tabs
            initialIndex={initialMode === 'sign-in' ? 1 : 0}
            ariaLabel="auth-tab"
            isFullWidth
            handleClick={(tabIndex) =>
                triggerTracking({
                    event: 'GAEvent',
                    eventCategory: 'registration',
                    eventAction: tabIndex
                        ? 'click_to_signin'
                        : 'click_to_register',
                    eventLabel: actionAfterAuth?.eventLabel
                })
            }
        >
            <Tab label={registerTitleTn}>
                <RegisterSection
                    {...props}
                    heading={heading || headingTn}
                    isShowing={isShowing}
                    close={close}
                    actionAfterAuth={actionAfterAuth}
                    resetActionAfterAuth={resetActionAfterAuth}
                    onSocialAuth={onSocialAuth}
                />
            </Tab>
            <Tab label={signInTitleTn}>
                <SignInSection
                    {...props}
                    isShowing={isShowing}
                    close={close}
                    actionAfterAuth={actionAfterAuth}
                    resetActionAfterAuth={resetActionAfterAuth}
                    onSocialAuth={onSocialAuth}
                />
            </Tab>
        </Tabs>
    );
};
